import type { UserCompanyMemberDto } from '@monorepo/shared';
import { DotsThreeVerticalIcon } from '@phosphor-icons/react';
import { UserRoleBadge } from './UserRoleBadge';
import { UserGroupsCell } from './UserGroupsCell';

interface UsersTableRowProps {
  user: UserCompanyMemberDto;
  isSelected: boolean;
  onToggleSelect: (userId: string) => void;
  isCurrentUserAdmin: boolean;
  onMenuToggle: (userId: string) => void;
  registerButtonRef: (userId: string, el: HTMLButtonElement | null) => void;
}

const getInitials = (firstName: string, lastName: string) =>
  `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

const formatDate = (date: Date) => new Date(date).toLocaleDateString('fr-FR');

export const UsersTableRow = ({
  user,
  isSelected,
  onToggleSelect,
  isCurrentUserAdmin,
  onMenuToggle,
  registerButtonRef,
}: UsersTableRowProps) => {
  return (
    <tr className="bg-white rounded-md shadow-sm border-b border-[#dee7ed] hover:bg-gray-50 transition">
      <td className="px-3 py-4 rounded-l-md">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggleSelect(user.id)}
          className="w-5 h-5 text-primary bg-white border-gray-300 rounded focus:ring-primary"
        />
      </td>
      <td className="w-full max-w-0 px-3 py-4">
        <div className="flex min-w-0 items-center">
          <div className="flex-shrink-0 w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center text-white font-medium">
            {getInitials(user.firstName, user.lastName)}
          </div>
          <div className="ml-4 min-w-0">
            <div className="truncate text-sm font-medium text-[#171a1c]">
              {user.firstName} {user.lastName}
            </div>
            <div className="truncate text-sm text-gray-500">{user.email}</div>
          </div>
        </div>
      </td>
      <td className="px-3 py-4 hidden md:table-cell">
        <UserRoleBadge role={user.role} />
      </td>
      <td className="px-3 py-4 hidden lg:table-cell">
        <UserGroupsCell groups={user.groups ?? []} />
      </td>
      <td className="px-3 py-4 text-sm text-gray-500 hidden xl:table-cell">
        {user?.lastLoginAt ? formatDate(user.lastLoginAt) : '-'}
      </td>
      <td className="px-3 py-2 text-right rounded-r-md">
        {isCurrentUserAdmin && (
          <button
            ref={(el) => registerButtonRef(user.id, el)}
            onClick={() => onMenuToggle(user.id)}
            className="action-button bg-white border border-[#becfda] p-2 rounded-md shadow-sm hover:bg-gray-50 transition"
          >
            <DotsThreeVerticalIcon size={20} weight="bold" className="text-[#171a1c]" />
          </button>
        )}
      </td>
    </tr>
  );
};
